import { Component, OnInit } from '@angular/core';
import { Modelcores } from 'src/app/entity/Pjoint';
import { AppSettings } from 'src/app/service/app.setting';
import { environment } from 'src/environments/environment';
import { AdminService } from 'src/app/service/admin.service';
import saveAs from 'save-as'
@Component({
  selector: 'app-modele',
  templateUrl: './modele.component.html',
  styleUrls: ['./modele.component.css']
})
export class ModeleComponent implements OnInit {
  uploadUrl: String = environment.restApiCRM+'/mails/upload1';
  loading
  selectedModelcores: Modelcores;
  modelcores: Modelcores[]
  cols:any;
  isEdit:boolean;
  constructor(private adminService: AdminService) { }

  ngOnInit() {
    this.cols = [

      { field: 'nom', header: 'Nom' }
    ];
    this.findAllModelcores()
  }
  uploadedFiles: any[] = [];
  file: File;
  openFile(blob: any) {

    saveAs(blob, blob.name)
  }
  removePJ(file: File) {
    let filesTemp: any[] = [];
    this.uploadedFiles.forEach(element => {
      if (element !== file)
        filesTemp.push(element);
    });
    this.uploadedFiles = filesTemp;
  }
 formatBytes(a, b) { if (0 == a) return "0 Bytes"; var c = 1024, d = b || 2, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], f = Math.floor(Math.log(a) / Math.log(c)); return parseFloat((a / Math.pow(c, f)).toFixed(d)) + " " + e[f] }

  onUpload1(event) {

    for (let file of event.files) {

      this.uploadedFiles.push(file);
    }
  }
  findAllModelcores() {
    this.adminService.findAllModelsCoresp().subscribe(result => {
      this.modelcores = result
    })
  }


  createModelcores() {
    let modelcores: Modelcores = new Modelcores()
    modelcores.designation = "new Model"
    this.adminService.createModelsCoresp(modelcores).subscribe(result => {
      this.findAllModelcores()
    })
  }

  save() {

    this.adminService.saveModelsCoresp(this.selectedModelcores).subscribe(result => {

    })
  }

  removeModelcores() {
    this.adminService.removeModelsCoresp(this.selectedModelcores).subscribe(result => {
      let resSTR = JSON.stringify(result);
      let resJSON = JSON.parse(resSTR);
  
this.findAllModelcores()
    },error=>
 ( alert(error) ))

  }
  

  selectedProject: String[];
  projets = [
    { label: 'HASSI', value: 'HASSI' },
    { label: 'NAPEC', value: 'NAPEC' },
    { label: 'DELEGATE', value: 'DELEGATE' },
    { label: 'SPONSOR', value: 'SPONSOR' }
  ];
  selectProjectPr() {


    this.selectedModelcores.projets = this.selectedProject.join(' ');

   
  }
  public CkeditorConfig1 = {
    allowedContent: true,
    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',
    CKEDITOR: [{dtd: {$removeEmpty: {i: 0} } } ],
    height: 400,
    toolbarGroups: [ ]
  }
  public CkeditorConfig = {
    allowedContent: true,
    extraAllowedContent: 'p(*)[*]{*};div(*)[*]{*};li(*)[*]{*};ul(*)[*]{*};span(*);i(*);',
    CKEDITOR: [{dtd: {$removeEmpty: {i: 0} } } ],
    height: 400,
    toolbarGroups: [ 
 
     
      { name: 'forms', groups: [ 'forms' ] },
      { name: 'styles', groups: [ 'styles' ] },
      { name: 'colors', groups: [ 'colors' ] },
      { name: 'links', groups: ['links'] },
     
      { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
      { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
 
       
  ],
    removeButtons: 'Save,NewPage,Print,Paste,PasteText,PasteFromWord,Scayt,Form,Radio,Checkbox,TextField,Textarea,Select,Button,ImageButton,HiddenField',
    removePlugins: 'htmldataprocesor',
    protectedSource: [ /{{[\s\S]*?}}/g ],
    //CKEDITOR.dtd:[{$removeEmpty:{i: false}}]
   // CKEDITOR.dtd:false
    //.dtd.$removeEmpty['i'] = false

   }
  public CKEDITOR= []; 
}
